import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';

/** POST /api/transportista/satisfaccion/set */
@Injectable({ providedIn: 'root' })
export class TransportistaSatisfaccionSetGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  post(
    body: Record<string, string | null | undefined>,
    options?: TransportistaGatewayPostOptions
  ): Observable<unknown> {
    return this.gw.post<unknown>('/satisfaccion/set', body, options);
  }
}
